// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionInfoModal__root--1VdYf","root_rebrandingQuotaLanding":"SubscriptionInfoModal__root_rebrandingQuotaLanding--2UnlS"};